import React, { useState, useEffect } from "react";

import { isMobile } from 'react-device-detect';

import styled from 'styled-components';

const OptionRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 8px;
  gap: 16px;
  button {
    flex-shrink: 0;
  }

  .fieldBox {
    max-width: 320px;
    margin-left: auto;
  }

  @media (max-width: 1300px) {
    margin-top: 0.62vw;
    gap: 1.23vw;
  }

  @media (max-width: 768px) {
    margin-top: ${(props) => (props.$mobile ? "8px" : "4px")};
    gap: ${(props) => (props.$mobile ? "8px" : "4px")};
  }
`;

function CheckBoxSelector({
  label,
  options,
  selectedItems,
  setSelectedItems,
  maxDisplayCount = 12, // 기본 표시 개수 (한 줄 4개씩 2줄 등)
}) {
  
  const [showMore, setShowMore] = useState(false);
  // 직접 입력 필드 상태 (만약 DB에서 직접 입력한 값이 있으면 이 state에 담김)
  const [customItem, setCustomItem] = useState("");

  // 선택한 옵션 앞 순서로 정렬
  const sortedOptions = options.sort((a, b) => {
    const isASelected = selectedItems.includes(a);
    const isBSelected = selectedItems.includes(b);
    
    if (isASelected && !isBSelected) return -1;    
    if (!isASelected && isBSelected) return 1;
    return 0;
  });

  // DB에서 불러온 selectedItems 중 options에 없는 값은 직접 입력한 값으로 간주
  useEffect(() => {
    const custom = selectedItems.find((item) => !options.includes(item));
    if (custom) {
      setCustomItem(custom);
    } else {
      setCustomItem("");
    }
  }, [selectedItems, options]);

  const displayedOptions = showMore ? sortedOptions : sortedOptions.slice(0, maxDisplayCount);

  const toggleItem = (item) => {
    if (selectedItems.includes(item)) {
      return setSelectedItems(selectedItems.filter((i) => i !== item));
    } else {
      return setSelectedItems([...selectedItems, item]);
    }
  };

  // 직접 입력 필드 변경 시 selectedItems에도 반영
  const handleCustomItemChange = (e) => {
    const newValue = e.target.value;
    setCustomItem(newValue);

    // 이미 custom item이 있는지 체크 (options에 없는 항목)
    const existingCustomIndex = selectedItems.findIndex(
      (item) => !options.includes(item)
    );

    if (existingCustomIndex !== -1) {
      const newSelected = [...selectedItems];
      if (newValue.trim() === "") {
        // 입력이 지워졌다면 selectedItems에서 제거
        newSelected.splice(existingCustomIndex, 1);
      } else {
        // 수정한 값을 반영
        newSelected[existingCustomIndex] = newValue;
      }
      setSelectedItems(newSelected);
    } else {
      // 기존에 없고, 새 값이 있다면 추가
      if (newValue.trim() !== "") {
        setSelectedItems([...selectedItems, newValue]);
      }
    }
  };

  return (
    <div className="formRow fullWidth">
      {
        label
        ?
        (
          <div className="labelBox">
            <label>{ label }</label>
          </div>
        )
        :
        null
      }
      <div className="fieldBox checkBox">
      {
        displayedOptions.map((item) => (
          <div key={ item } className="eachBox">
            <input
              type="checkbox"
              name={ label }
              id={`${ label }_${ item }`}
              checked={ selectedItems.includes(item) }
              onChange={ () => toggleItem(item) }
            />
            <label htmlFor={`${ label }_${ item }`}>{ item }</label>
        </div>
        ))
      }
      </div>
      <OptionRow $mobile={ isMobile }>
        {
          showMore
          ?
          (
          <button type="button" onClick={ () => setShowMore(false) }>
            <div className={`commonIcon ${ isMobile ? 'mobile' : null }`}>
              <i className="minusBlack w24"></i>
              접기
            </div>
          </button>
          )
          :
          (
          <button type="button" onClick={ () => setShowMore(true) }>
            <div className={`commonIcon ${ isMobile ? 'mobile' : null }`}>
              <i className="plusBlack w24"></i>
              더보기
            </div>
          </button>
          )
        }
        {/* 직접 입력 필드 */}
        <div className="fieldBox">
          <input type="text" placeholder="직접 입력" value={ customItem } onChange={ handleCustomItemChange } />
        </div>
      </OptionRow>
    </div>
  );
}

export default CheckBoxSelector;